import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface CTAButtonProps {
  text: string;
  subtext?: string;
  className?: string;
  onClick?: () => void;
}
export function CTAButton({
  text,
  subtext,
  className = '',
  onClick
}: CTAButtonProps) {
  const purchaseUrl = 'https://libroalclick.shop/cart/47696256467203:1';
  const handleClick = () => {
    if (onClick) {
      onClick();
    }
    window.location.href = purchaseUrl;
  };
  return <motion.button whileHover={{
    scale: 1.05
  }} whileTap={{
    scale: 0.95
  }} animate={{
    boxShadow: ['0 0 0 0 rgba(220, 38, 38, 0.7)', '0 0 0 10px rgba(220, 38, 38, 0)']
  }} transition={{
    boxShadow: {
      duration: 2,
      repeat: Infinity,
      repeatType: 'loop'
    },
    scale: {
      duration: 0.2
    }
  }} onClick={handleClick} className={`
        relative group flex flex-col items-center justify-center 
        w-full max-w-md mx-auto px-8 py-4 
        bg-gradient-to-r from-red-600 to-red-700 
        hover:from-red-500 hover:to-red-600
        text-white rounded-lg shadow-xl 
        border-b-4 border-red-900 active:border-b-0 active:translate-y-1
        transition-all duration-200
        ${className}
      `} data-id="element-66">
      <div className="flex items-center gap-2 text-xl md:text-2xl font-bold uppercase tracking-wide" data-id="element-67">
        <span data-id="element-68">{text}</span>
        <ArrowRight className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-69" />
      </div>
      {subtext && <span className="text-xs md:text-sm text-red-100 mt-1 font-medium opacity-90" data-id="element-70">
          {subtext}
        </span>}
    </motion.button>;
}